module.exports = __webpack_public_path__ + "img/cx.46e11ba.svg";